import React, { useContext } from 'react'
import clsx from 'clsx'
import type { ComponentProps } from '../../types'
import { Button } from '../../../../components'
import type { ButtonProps } from '../../../../components/button/Button'
import WizardContext from '../Context/WizardContext'
import DataContext from '../../DataContext/Context'
import ButtonRow from '../../Form/ButtonRow'
import useTranslation from '../../hooks/useTranslation'
import withComponentMarkers from '../../../../shared/helpers/withComponentMarkers'

export type WizardPreviousButtonProps = ComponentProps & ButtonProps

function PreviousButton(props: WizardPreviousButtonProps) {
  const translations = useTranslation().WizardPreviousButton

  const {
    className,
    variant = 'tertiary',
    iconPosition = 'left',
    icon = 'chevron_left',
    children = translations.text,
  } = props
  const { activeIndex, handlePrevious } = useContext(WizardContext) || {}

  const { prerenderFieldProps } = useContext(DataContext)
  if (prerenderFieldProps) {
    return null as React.JSX.Element
  }

  const params: WizardPreviousButtonProps = {}
  if (activeIndex === 0) {
    params.disabled = true
  }

  return (
    <ButtonRow>
      <Button
        className={clsx('dnb-forms-previous-button', className)}
        onClick={handlePrevious}
        variant={variant}
        iconPosition={iconPosition}
        icon={icon}
        {...params}
        {...props}
      >
        {children}
      </Button>
    </ButtonRow>
  )
}

withComponentMarkers(PreviousButton, {
  _supportsSpacingProps: true,
})

export default PreviousButton
